import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiCheckbox } from "@miplatform/components";
import { ICONS_WEB } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, TextField } from "@mui/material";
import { MaterialCard } from "../../../../components/MaterialCard/MaterialCard";

export function ItemTemplatePlanMaterial({
  material,
  itemTemplate,
  isLoading,
  isAreaSelected,
  setSelectedItems,
  selectedItems = [],
  selectedItemTemplate,
}) {
  const { classes } = useStyles();

  const { quantity = "", suppliedByBuilder = false } =
    itemTemplate.planAreaMaterials.find((m) => m.materialId === material.id) ||
    {};

  useEffect(() => {
    if (isAreaSelected) {
      setSelectedItems(selectedItemTemplate[0]?.planAreaMaterials);
    }
  }, [isAreaSelected]);

  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      setSelectedItems((prev) => [
        ...prev,
        { ...material, materialId: material.id, suppliedByBuilder, quantity },
      ]);
    } else {
      setSelectedItems((prev) =>
        prev.filter((i) => i.materialId !== material.id)
      );
    }
  };

  const isItemInSelectedItems = selectedItems?.some(
    (i) => i.materialId === material.id
  );

  const getIcons = () => {
    const icons = [];
    if (suppliedByBuilder) {
      icons.push({ path: mdi[ICONS_WEB.ACCOUNT_HARDHAT_OUTLINE] });
    }
    return icons;
  };

  return (
    <MaterialCard
      item={material}
      isSelected={isItemInSelectedItems && isAreaSelected}
      leftAction={
        <Box className={classes.leftAction}>
          {isAreaSelected && (
            <MiCheckbox
              value={isItemInSelectedItems}
              handleChange={handleCheckboxChange}
            />
          )}
          <TextField
            value={quantity}
            sx={{ width: 55 }}
            disabled
            size="small"
          />
        </Box>
      }
      isSuppliedByBuilder={suppliedByBuilder}
      icons={getIcons()}
      showPrice
      isLoading={isLoading}
    />
  );
}

const useStyles = makeStyles()(() => ({
  leftAction: {
    padding: 4,
    display: "flex",
  },
}));
